var map = {
	"./symbol_0.png": "263b",
	"./symbol_1.png": "592b",
	"./symbol_10.png": "11c6",
	"./symbol_11.png": "a75a",
	"./symbol_12.png": "912c",
	"./symbol_2.png": "a2b5",
	"./symbol_3.png": "33ad",
	"./symbol_4.png": "bfb5",
	"./symbol_5.png": "bfb0",
	"./symbol_6.png": "625d",
	"./symbol_7.png": "1e57",
	"./symbol_8.png": "48f8",
	"./symbol_9.png": "98ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9e4";